const META_JOBS = ['meta_refresh', 'meta_history']
const STATUS_PRIORITY = [3, 4, 1, 0, 2]

const latestTime = (task) => Date.parse(task.completedAt || task.startAt) || 0

// 只合并展示：采集任务仍独立运行，子任务保留各自的状态和时间。
export function groupMetaTasks(tasks = []) {
  const metaJobs = tasks.filter((task) => META_JOBS.includes(task.taskType))
  if (metaJobs.length === 0) return tasks

  const jobs = META_JOBS.map((type) => {
    const job = metaJobs.find((task) => task.taskType === type)
    if (!job) return { taskType: type, status: 0 }
    // 兼容现有 Server：回补的执行状态不受日常一小时新鲜度影响。
    return type === 'meta_history'
      ? { ...job, status: job.runStatus ?? (job.status === 4 ? 2 : job.status) }
      : job
  })
  const children = jobs.flatMap((job) => ['cost', 'revenue'].map((kind) => {
    const type = `${job.taskType}_${kind}`
    const child = job.children?.find((item) => item.taskType === type || item.task === type)
    const history = job.taskType === 'meta_history'
    const status = child
      ? history ? child.runStatus ?? (child.status === 4 ? 2 : child.status) : child.status
      : job.status === 3 ? 3 : 0
    return {
      ...child,
      task: type,
      taskType: type,
      taskName: `${kind === 'cost' ? 'Cost' : 'Revenue'}${history ? ' 回补' : ''}`,
      status,
      freshness: history ? null : child?.freshness,
    }
  }))
  const status = STATUS_PRIORITY.find((value) => [...jobs, ...children].some((task) => task.status === value)) ?? 0
  // 组时间来自决定组状态的任务，避免把一次日常成功当成回补成功。
  const selectedJob = jobs.filter((job) => job.status === status).sort((a, b) => latestTime(b) - latestTime(a))[0]
    ?? children.filter((child) => child.status === status).sort((a, b) => latestTime(b) - latestTime(a))[0]
    ?? jobs.slice().sort((a, b) => latestTime(b) - latestTime(a))[0]
  const group = {
    ...selectedJob,
    task: 'meta_update',
    taskType: 'meta_update',
    taskName: 'Meta 更新',
    status,
    completedAt: status === 1 ? null : selectedJob.completedAt,
    freshness: jobs[0].freshness,
    children,
    childStatusCount: { success: children.filter((child) => child.status === 2).length, total: 4 },
  }
  const firstMeta = tasks.findIndex((task) => META_JOBS.includes(task.taskType))
  return tasks.flatMap((task, index) => index === firstMeta ? [group] : META_JOBS.includes(task.taskType) ? [] : [task])
}
